export default __webpack_public_path__ + "static/media/open-pokeball.26c9b52e.svg";